mutation UnpauseDripSequence($input: DripSequenceUnpauseInput!) {
    dripSequenceUnpause(input: $input) {
        dripSequence {
            id
        }
    }
}
